//initialize battery heartbeat
import {
    BatteryActions,
    BatteryHeartbeat,
    BatteryHeartbeatAction,
    BillingAction,
    BillingState,
    CustomerBillingItem, UsersActions, UsersState
} from "../../types";
import dayjs from 'dayjs';
import {Dispatch} from "react";
import {apiResponse} from "./common-actions";
import {BatteryManagementServiceClient} from "../../protobuf/Battery_serviceServiceClientPb";
import {batteryManagmentServiceClient, billingServiceClient} from "../../utils/grpc-clients";
import {useDispatch} from "react-redux";
import {
    GetLatestBillByCustomerRequest,
    GetLatestBillByCustomerResponse,
    GetPackageListRequest, GetPackageListResponse, GetPlansByPackageIDRequest, GetPlansByPackageIDResponse,
    GetSubscriptionGroupsByClientIDRequest, GetSubscriptionGroupsByClientIDResponse,
    GetTotalNetSwapsByClientRequest,
    GetTotalNetSwapsByClientResponse, PackageListItem, PlanListItem, SubscriptionGroupItem
} from "../../protobuf/billing_service_pb";
import {BillingServiceClient} from "../../protobuf/Billing_serviceServiceClientPb";
import {Struct} from "google-protobuf/google/protobuf/struct_pb";

function getMonthName(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleString('default', { month: 'long' });
}

export function initializeCustomerBilling({organization_id, date}:{organization_id:string, date:string}){

    const isValidDate = dayjs(date, 'YYYY-MM-DD', true).isValid(); // Validate the date format
    const validDate = isValidDate ? date : dayjs().format('YYYY-MM-DD'); // Use current date if invalid

    console.log("customer id : ", organization_id)
    console.log("Date : ", validDate)
    const request = new GetLatestBillByCustomerRequest()
    request.setCustomerId(organization_id || "")
    request.setDate(validDate|| '')
    
    return async (dispatch: Dispatch<any>) => {
        function dispatcher(resp: GetLatestBillByCustomerResponse) {  
         
                const customerBill: CustomerBillingItem = resp?.getBill()?.toObject() as CustomerBillingItem;
                console.log("customer bill:-------------------------", customerBill);
                dispatch(setCustomerBill(customerBill));
                const totalBill = getTotalFromStruct(resp?.getBill()?.getComponents(), 'grandTotal');
                console.log("total bill from action : ", totalBill);
                dispatch(setTotalBill("PKR " + totalBill));
              
            
        }
        dispatch(
            apiResponse<
                BillingServiceClient,
                GetLatestBillByCustomerRequest,
                GetLatestBillByCustomerResponse
            >({
                client: billingServiceClient,
                action: "getLatestBillByCustomer",
                request,
                errorMessage: "No bill found for "+ getMonthName(validDate),
                dispatcher,
            })
        );
    };
}


export function getPackageList(){

    const request = new GetPackageListRequest()

    return async (dispatch: Dispatch<any>) => {
        function dispatcher(resp: GetPackageListResponse) {

            const packageList: PackageListItem.AsObject[] = resp?.getPackageListList().map((p) => {
                return p.toObject()
            })
            dispatch(setPackageList(packageList))
        }
        dispatch(
            apiResponse<
                BillingServiceClient,
                GetPackageListRequest,
                GetPackageListResponse
            >({
                client: billingServiceClient,
                action: "getPackageList",
                request,
                dispatcher,
            })
        );
    };
}

export function getPlanList({id}:{id:string}){

    const request = new GetPlansByPackageIDRequest()
    request.setPackageId(id)
    return async (dispatch: Dispatch<any>) => {
        function dispatcher(resp: GetPlansByPackageIDResponse) {

            const planList: PlanListItem.AsObject[] = resp?.getPlanListList().map((p) => {
                return p.toObject()
            })
            dispatch(setPlanList(planList))
        }
        dispatch(
            apiResponse<
                BillingServiceClient,
                GetPlansByPackageIDRequest,
                GetPlansByPackageIDResponse
            >({
                client: billingServiceClient,
                action: "getPlansByPackageID",
                request,
                dispatcher,
            })
        );
    };
}



export function getSubscriptionGroupsByClient({ clientId }: { clientId: string }) {
    const request = new GetSubscriptionGroupsByClientIDRequest();
    request.setClientId(clientId || "");

    return async (dispatch: Dispatch<any>) => {
        function dispatcher(resp: GetSubscriptionGroupsByClientIDResponse) {
            const groups: SubscriptionGroupItem.AsObject[] = resp
                .getSubscriptionGroupsList()
                .map((g) => g.toObject());
            dispatch(setSubscriptionGroups(groups));
        }
        dispatch(
            apiResponse<
                BillingServiceClient,
                GetSubscriptionGroupsByClientIDRequest,
                GetSubscriptionGroupsByClientIDResponse
            >({
                client: billingServiceClient,
                action: "getSubscriptionGroupsByClientID",
                request,
                dispatcher,
            })
        );
    };
}

export function setSubscriptionGroups(
    payload: BillingState["subscriptionGroups"]
): BillingAction {
    return {
        type: "SET_SUBSCRIPTION_GROUPS",
        payload,
    };
}

export function setPackageList(
    payload: BillingState["packages"]
): BillingAction {
    return {
        type: "SET_PACKAGE_LIST",
        payload,
    };
}

export function setPlanList(
    payload: BillingState["plans"]
): BillingAction {
    return {
        type: "SET_PLAN_LIST",
        payload,
    };
}


export function setCustomerBill(
    payload: CustomerBillingItem = {} as CustomerBillingItem
): BillingAction {
    console.log("Bill from API : ", payload)
    return {
        type: "SET_BILL",
        payload,
    }
}

export function setNetSwaps(payload: number): BillingAction {
  return {
    type: "SET_NET_SWAPS",
    payload,
  };
}

export function setTotalBill(payload:string):BillingAction {
    return {
        type: "SET_TOTAL_BILL",
        payload
    }
}


export function getTotalFromStruct(struct?: Struct, key?: string): number | null {
    const fieldsMap = struct?.getFieldsMap();
    const totalField = fieldsMap?.get(key || "");

    if (totalField && totalField.hasNumberValue()) {
        return totalField.getNumberValue();
    }

    return null;
}

 // Function to extract the numberValue for a given key
export function getNumberValue(fieldsMap: [string, { nullValue: number, numberValue: number, stringValue: string, boolValue: boolean }][], key: string): number | undefined {
    const entry = fieldsMap.find(([k]) => k === key);
    return entry ? entry[1].numberValue : undefined;
}

export function formatCamelCaseToString(camelCaseString:string) : string {
    // Insert a space before each uppercase letter and capitalize the first letter
    return camelCaseString
        .replace(/([A-Z])/g, ' $1')  // Insert space before each uppercase letter
        .replace(/^./, str => str.toUpperCase()); // Capitalize the first letter

}

export function formatDate(inputDate:string) {
    console.log( 'DUE DATE:',inputDate);
    // Create a new Date object from the input date string
    const date = new Date(inputDate);
    // Define the array of month names
    const monthNames = [
        "January", "February", "March", "April", "May", "June", "July",
        "August", "September", "October", "November", "December"
    ];

    // Format the date to "28 August 2025"
    const formattedDate = `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;
    return formattedDate;
}

export const monthNames = [
    "January", "February", "March", "April", "May", "June", "July",
    "August", "September", "October", "November", "December"
];

  export function getNetSwapsCountbyDateByClient({
    client_id,
    start_date,
    end_date,
  }: {
    client_id: string;
    start_date: string;
    end_date: string;
  }) { 
    const isValidStartDate = dayjs(start_date, 'YYYY-MM-DD', true).isValid();
    const isValidEndDate = dayjs(end_date, 'YYYY-MM-DD', true).isValid();
  
    const validStartDate = isValidStartDate ? start_date : dayjs().format('YYYY-MM-DD');
    const validEndDate = isValidEndDate ? end_date : dayjs().format('YYYY-MM-DD');
  
    const request = new GetTotalNetSwapsByClientRequest();
    request.setClientId(client_id || "");
    request.setFrom(validStartDate || "");
    request.setTo(validEndDate || "");
    return async (dispatch: Dispatch<any>) => {
      function dispatcher(resp: GetTotalNetSwapsByClientResponse) { {
        const totalNetSwaps = resp.getTotalNetSwaps();
          console.log("totalNETSwaps:::::::::::",totalNetSwaps);
        dispatch(setNetSwaps(totalNetSwaps));
      }
    }
      dispatch(
        apiResponse<
          BillingServiceClient,
          GetTotalNetSwapsByClientRequest,
          GetTotalNetSwapsByClientResponse
        >({
          client: billingServiceClient,
          action: "getTotalNetSwapsByClient",
          request,
          dispatcher,
        })
      );
    };
  }
